import { gql } from "@apollo/client";

export const DOCUMENT_TYPE_INFO_FRAGMENT = gql`
  fragment DocumentTypeInfoFragment on DocumentTypeInfo {
    type
    title
    description
    count
    unreadCount
  }
`;

export const DOCUMENT_LIST_FRAGMENT = gql`
  fragment DocumentListFragment on Document {
    id
    title
    type
    documentDate
    isRead
  }
`;

export const DOCUMENT_FRAGMENT = gql`
  fragment DocumentFragment on Document {
    id
    title
    type
    documentDate
    url
    isRead
  }
`;
